export const PASSWORD_REGEX = /^[a-z0-9$@!%*#_~?&]{8,16}$/i;
export const PASSWORD_REGEX_MSG =
  '请输入正确的密码格式，仅支持大小写字母、数字和$@!%*#_~?&';
export const VALID_CODE_REGEX = /^[a-z0-9]{4}$/i;
export const VALID_CODE_REGEX_MSG = '请填写正确的验证码格式';
